import App from "@/App.vue";

export default [
  {
    path: "/escritorios",
    name: "office",
    component: App,
    redirect: { name: "office list" },
    children: [
      {
        path: "",
        name: "office list",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/OfficeList.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Escritórios",
              disabled: false,
              link: false,
              to: { name: "office" }
            }
          ],
          displayName: "Lista Usuários - Lockton",
          requiresAuth: true,
          permissionRoute: "visualizar_escritorio"
        }
      },
      {
        path: "editar-escritorio/:id",
        name: "office edit",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditOffice.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Editar Escritório",
              disabled: false,
              link: true,
              to: { name: "office" }
            }
          ],
          displayName: "Editar Escritório - Lockton",
          requiresAuth: true,
          permissionRoute: "editar_escritorio"
        }
      },
      {
        path: "novo-escritorio",
        name: "office new",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewOffice.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Novo Escritório",
              disabled: false,
              link: true,
              to: { name: "office" }
            }
          ],
          displayName: "Novo Escritório - Lockton",
          requiresAuth: true,
          permissionRoute: "criar_escritorio"
        }
      }
    ]
  }
];
